var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#caret-right';
                    var viewUrl = 'svg/icons.svg#view-caret-right';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 17',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };